import type { IconData } from '@stacksjs/iconify-core'

export const programmingCode: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m0 8l5.5-5.5L8 5L5 8l3 3l-2.5 2.5zm8 3l3-3l-3-3l2.5-2.5L16 8l-5.5 5.5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default programmingCode
